import styleReport from "./Report.module.css"
import React, {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import Select from "../../components/Select/Select";
import Utils from "../../utils/Utils";
import oggettiUtili from "../../utils/OggettiUtili.json";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ComposedChart,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import Table from "../../components/table/Table";
import style from "../registro/ElencoAssistentiFamiliari.module.css";
import Pagination from "../../components/pagination/Pagination";
import Button from "../../components/Button/Button";
import ReportService from "../../services/ReportService";
import FeedbackService from "../../services/FeedbackService";
import Spinner from "../../components/spinner/Spinner";

function Report(props){

    const [state, setState] = useState({});

    const selectOptionsPeriodo = oggettiUtili.periodoReport
    const [pagination, setPagination] = useState({size: 10, page: 0, sort: "nomeSportello", order: "asc"})
    const [paginationFeedback, setPaginationFeedback] = useState({size: 10, page: 0, sort: "nomeSportello", order: "asc", paginazione: true})
    const [dataGrafico1, setDataGrafico1] = useState( {numSportelli: 0, numUtenti: 0,numAssistenti:0})
    const [dataGrafico2, setDataGrafico2] = useState( [])
    const [dataGrafico2Totale, setDataGrafico2Totale] = useState({})
    const [boxGrafico2, setBoxGrafico2] = useState([])

    const [grafico2AccessiOggi, setGrafico2AccessiOggi] = useState(0)
    const [grafico2MediaGiornaliera, setGrafico2MediaGiornaliera] = useState(0)
    const [grafico2MediaMensile, setGrafico2MediaMensile] = useState(0)

    const [dataGrafico2atorta, setDataGrafico2atorta] = useState([
        { name: 'Assistenti Familiari disattivati', value: 0 , color: '#FF8042'},
        { name: 'Assistenti Familiari attivi', value: 0  ,color: '#418ab4'},])
    const [dataGrafico3UtentiRegionali, setDataGrafico3UtentiRegionali] = useState([{name: 'RDSS', ruolo: 0},
        {name: 'RULSS',  ruolo: 0},
        {name: 'RdS',  ruolo: 0},
        {name: 'Admin', ruolo: 0}])
    const [dataGrafico6Province, setDataGrafico6Province] = useState([
        {name: 'VI', value: 0, color: '#27536a'},
        {name: 'VR', value: 0, color: '#e05327'},
        {name: 'TV', value: 0, color: '#fdc403'},
        {name: 'RO', value: 0, color: '#848484'},
        {name: 'BL', value: 0, color: '#FF8042'},
        {name: 'PD', value: 0, color: "#a7b727"},
        {name: 'VE', value: 0, color: '#418ab4'},
    ])
    const [dataGrafico7RicerchePerTerritorio, setDataGrafico7RicerchePerTerritorio] = useState([
        {name: 'VI', value: 0, color: '#27536a'},
        {name: 'VR', value: 0, color: '#a7b727'},
        {name: 'TV', value: 0, color: '#599bd5'},
        {name: 'RO', value: 0, color: '#fdc403'},
        {name: 'BL', value: 0, color: '#848484'},
        {name: 'PD', value: 0, color: "#FF8042"},
        {name: 'VE', value: 0, color: '#418ab4'},
    ])
    const [dataGrafico89atorta, setDataGrafico89atorta] = useState({
        dataGrafico8atorta : [
            { name: 'Rdss', value: 0 , color: '#599bd5'},
            { name: 'Rds', value: 0 ,color: '#FF8042'},
            { name: 'Admin', value: 0 ,color: '#a7b727'},
            { name: 'Rulss', value: 0 ,color: '#fdc403'},
            { name: 'Af', value: 0 ,color: '#418ab4'}
        ],
        dataGrafico9atorta: [
            { name: 'Si', value: 0 , color: 'brown'},
            { name: 'No', value: 0 ,color: '#ffcc00'}
        ]
    })
    const colsFeedback = [
        {name: "Data", key: "data", typeSort: "ASC"},
        {name: "Testo", key: "feedback", typeSort: "ASC"},
        {name: "Stato", key: "stato", typeSort: "ASC", type: "map", mapContent: oggettiUtili.statoFeedback },
        {type: "button", key: "id", typeButton: "White", text: "Archivia", className: style.buttonTable,  onClick:modificaStatoFeedback},
        {type: "button", key: "id", typeButton: "White", text: "Elimina", className: style.buttonTable, onClick:eliminaFeedback}
    ]
    const colsSportelloAssistenti = [
        {name: "Nome Sportello", key: "nomeSportello"},
        {name: "Assistenti Familiari Registrati", key: "numAssistenti"}
    ]
    const [rowsFeedback, setRowsFeedback] = useState([])
    const [rowsSportelloAssistenti, setRowsSportelloAssistenti] = useState([])
    const [tableFeedback, setTableFeedback] = useState([])
    const [showSpinner, setShowSpinner] = useState(false)

    useEffect(()=>{
        setShowSpinner(true)
        ReportService.getReport().then(res => {

            if(res.data){
                setDataGrafico1({numSportelli: res.data.grafico1.numSportelli, numUtenti: res.data.infoAPMS.utentiTotali, numAssistenti: res.data.grafico1.numAssistenti})
                setDataGrafico2Totale(res.data.grafico2)
                let mesiGrafico2Value = []

                res.data.grafico2.ultimiDodiciMesi.forEach( mese => {
                    let meseCopy = {...mese}
                    meseCopy.data = oggettiUtili.docidiMesi[meseCopy.data.toString()]
                   mesiGrafico2Value.push(meseCopy)
                })

                setGrafico2AccessiOggi(res.data.grafico2.accessiOggi)
                setDataGrafico2(mesiGrafico2Value)


                renderGrafico2()

                setDataGrafico2atorta([
                    { name: 'Assistenti Familiari disattivati', value: res.data.grafico3.disattivati , color: '#FF8042'},
                    { name: 'Assistenti Familiari attivi', value: res.data.grafico3.attivi  ,color: '#418ab4'}])
                setDataGrafico3UtentiRegionali([
                    {name: 'RDSS', ruolo: res.data.infoAPMS.UtentiPerRuolo.RDSS},
                    {name: 'RULSS',  ruolo: res.data.infoAPMS.UtentiPerRuolo.RULSS},
                    {name: 'RdS',  ruolo: res.data.infoAPMS.UtentiPerRuolo.RdS},
                    {name: 'Admin', ruolo: res.data.infoAPMS.UtentiPerRuolo.Admin}])
                setDataGrafico6Province([
                    {name: 'VI', value: res.data.grafico6.vi, color: '#27536a'},
                    {name: 'VR', value: res.data.grafico6.vr, color: '#e05327'},
                    {name: 'TV', value: res.data.grafico6.tv, color: '#fdc403'},
                    {name: 'RO', value: res.data.grafico6.ro, color: '#848484'},
                    {name: 'BL', value: res.data.grafico6.bl, color: '#FF8042'},
                    {name: 'PD', value: res.data.grafico6.pd, color: "#a7b727"},
                    {name: 'VE', value: res.data.grafico6.ve, color: '#418ab4'}])
                setDataGrafico7RicerchePerTerritorio([
                    {name: 'VI', value: res.data.grafico7.vi, color: '#27536a'},
                    {name: 'VR', value: res.data.grafico7.vr, color: '#e05327'},
                    {name: 'TV', value: res.data.grafico7.tv, color: '#fdc403'},
                    {name: 'RO', value: res.data.grafico7.ro, color: '#848484'},
                    {name: 'BL', value: res.data.grafico7.bl, color: '#FF8042'},
                    {name: 'PD', value: res.data.grafico7.pd, color: "#a7b727"},
                    {name: 'VE', value: res.data.grafico7.ve, color: '#418ab4'}])

                let grafico8 = [
                    { name: 'Rdss', value: res.data.grafico8.rdss , color: '#599bd5'},
                    { name: 'Rds', value: res.data.grafico8.rds , color: '#FF8042'},
                    { name: 'Admin', value: res.data.grafico8.admin , color: '#a7b727'},
                    { name: 'Rulss', value: res.data.grafico8.rulss , color: '#fdc403'},
                    { name: 'Af', value: res.data.grafico8.af ,color: '#418ab4'}]

                let grafico9 = [
                    { name: 'Si', value: res.data.grafico9.si , color: 'brown'},
                    { name: 'No', value: res.data.grafico9.no ,color: '#ffcc00'}]

                let grafico89 = {...dataGrafico89atorta}

                grafico89.dataGrafico8atorta = grafico8
                grafico89.dataGrafico9atorta = grafico9

                setDataGrafico89atorta(grafico89)
            }
            setShowSpinner(false)
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation POST Report: " + reason)
        })
    },[])

    useEffect( ()=>{
        getGrafico5()
    }, [pagination.page,pagination.sort,pagination.order,pagination.size])

    useEffect( ()=>{
        getTabellaFeedback()
    }, [paginationFeedback.page,paginationFeedback.sort,paginationFeedback.order])

    useEffect( ()=>{
        renderGrafico2()
    }, [dataGrafico2, setDataGrafico2])

    function getGrafico5(){
        setShowSpinner(true)
        ReportService.getReportGrafico5(pagination).then(res => {

            if(res.data){
                let newPagination = {...pagination}
                newPagination.totalPages = res.data.sportelli.totalPages
                newPagination.totalElements = res.data.sportelli.totalElements
                setRowsSportelloAssistenti(res.data.sportelli.content)
                setPagination(newPagination)
            }
            setShowSpinner(false)
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation POST Report Grafico 5: " + reason)
        })
    }

    function getTabellaFeedback(){
        setShowSpinner(true)
        FeedbackService.getAllFeedback(paginationFeedback).then(res => {

            if(res.data){
                let newPaginationFeedback = {...paginationFeedback}
                newPaginationFeedback.totalPages = res.data.totalPages
                newPaginationFeedback.totalElements = res.data.totalElements

                let fedback = res.data.content

                for(let i=0;i<fedback.length;i++){
                    fedback[i].data = Utils.transformDateForFrontend(fedback[i].data)
                    if(fedback[i].stato === 2) fedback[i].disabled = true
                    else fedback[i].disabled = false
                }
                setRowsFeedback(fedback)
                setPaginationFeedback(newPaginationFeedback)

            }
            setShowSpinner(false)
        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation POST Report Grafico 5: " + reason)
        })
    }


    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };


    function changePage(newPage) {
        let newPagination = {...pagination}
        newPagination.page = newPage
        setPagination(newPagination)
    }

    function changePageFeedback(newPage) {
        let newPagination = {...paginationFeedback}
        newPagination.page = newPage
        setPaginationFeedback(newPagination)
    }

    function stampa(){
        window.print()
    }

    useEffect( ()=> {
        createTableFeedback()
    }, [ rowsFeedback, setRowsFeedback, setPaginationFeedback, paginationFeedback])

    function modificaStatoFeedback(id){
        let params = {
            stato: 2
        }
        FeedbackService.modificaStatoFeedback(id, params).then(res => {
            if(res.data){
                let newRow = res.data
                let rows = [...rowsFeedback]

                for(let i = 0; i<rows.length;i++){
                    if(rows[i].id === newRow.id){
                        rows[i] = newRow
                        rows[i].disabled = true
                    }
                }
                setRowsFeedback(rows)
            }
        }).catch(reason => {
            console.log("Errore Operation PUT feedback stato: " + reason)
        })
    }

    function eliminaFeedback(id){
        FeedbackService.eliminaFeedback(id).then(res => {

            let rows = [...rowsFeedback]

            for(let i = 0; i<rows.length;i++){
                if(rows[i].id === id){
                    rows.splice(i, 1);
                }
            }
            setRowsFeedback(rows)
        }).catch(reason => {
            console.log("Errore Operation DELETE feedback: " + reason)
        })
    }

    function createTableFeedback(){
       let tableContent = []
           tableContent.push(
            <div style={{marginTop: "40px"}} className={"noPrint"}>
                <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                <Row id={"grafico7"}>
                    <div style={{marginTop: "20px"}} className={"col-11"}>
                        <span style={{fontWeight: "bold", fontSize: "25px"}}>Segnalazioni e suggerimenti</span>
                        <Table
                            cols={colsFeedback}
                            rows={rowsFeedback}
                            id={"tabellaReport"}
                            setSort={setPaginationSort}
                        />
                        <Pagination pagination={paginationFeedback} changePage={changePageFeedback}/>
                    </div>
                </Row>
            </div>
           )

        setTableFeedback(tableContent)
    }

    function setPaginationSort(sort,order){
        let newPagination = {...paginationFeedback}
        newPagination.sort = sort
        newPagination.order = order
        setPaginationFeedback(newPagination)
    }

    function changePaginationSize(sort, direction, page, size) {

        let newPagination = {sort: "", order: "", page: "", size: 0, paginazione: true, totalPages: pagination.totalPages, totalElements: pagination.totalElements};
        if (sort !== null) {
            newPagination.sort = sort
        }

        if (direction !== null) {
            newPagination.order = direction
        }

        newPagination.page = page;
        newPagination.size = size;

        setPagination(newPagination)
    }



    function onClickSelectGrafico2(value){
        switch (value){
            case "01": {
                let mesiGrafico2Value = []

                dataGrafico2Totale.ultimiDodiciMesi.forEach( mese => {
                    let meseCopy = {...mese}
                    meseCopy.data = oggettiUtili.docidiMesi[meseCopy.data.toString()]
                    mesiGrafico2Value.push(meseCopy)
                })

                setDataGrafico2(mesiGrafico2Value)
                setGrafico2MediaGiornaliera(dataGrafico2Totale.mediaGiornalieraUltimiDodiciMesi)
                setGrafico2MediaMensile(dataGrafico2Totale.mediaMensileUltimiDodiciMesi)
                break
            }
            case "02": {
                let mesiGrafico2Value = []

                dataGrafico2Totale.ultimiSeiMesi.forEach( mese => {
                    let meseCopy = {...mese}
                    meseCopy.data = oggettiUtili.docidiMesi[meseCopy.data.toString()]
                    mesiGrafico2Value.push(meseCopy)
                })

                setDataGrafico2(mesiGrafico2Value)
                setGrafico2MediaGiornaliera(dataGrafico2Totale.mediaGiornalieraUltimiSeiMesi)
                setGrafico2MediaMensile(dataGrafico2Totale.mediaMensileUltimiSeiMesi)
                break
            }
            case "03": {
                let mesiGrafico2Value = []

                dataGrafico2Totale.ultimoMese.forEach( giorno => {
                    let giornoCopy = {...giorno}
                    giornoCopy.data = giornoCopy.data.toString()
                    mesiGrafico2Value.push(giornoCopy)
                })

                setDataGrafico2(mesiGrafico2Value)
                setGrafico2MediaGiornaliera(dataGrafico2Totale.mediaGiornalieraUltimoMese)
                setGrafico2MediaMensile(null)
                break
            }
            case "04": {
                let mesiGrafico2Value = []

                dataGrafico2Totale.ultimiSetteGiorni.forEach( giorno => {
                    let giornoCopy = {...giorno}
                    giornoCopy.data = giornoCopy.data.toString()
                    mesiGrafico2Value.push(giornoCopy)
                })

                setDataGrafico2(mesiGrafico2Value)
                setGrafico2MediaGiornaliera(dataGrafico2Totale.mediaGiornalieraUltimiSetteGiorni)
                setGrafico2MediaMensile(null)
                break;
            }
            default: break;
        }
    }

    function renderGrafico2(){
        let box = []

        box.push(
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    width={500}
                    height={400}
                    data={dataGrafico2}
                    margin={{top: 20, right: 20, bottom: 20, left: 20}}
                >
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis dataKey="data" scale="band" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="accessi" barSize={20} fill="#413ea0" />
                    {/*<Line type="monotone" dataKey="media" stroke="#ff7300" />*/}

                </ComposedChart>
            </ResponsiveContainer>
            )

        setBoxGrafico2(box)

    }

    return (

        <div id={"printArea"} className={styleReport.marginInitial}>
            <Spinner show={showSpinner}/>
            <h4 style={{marginLeft: "20px"}}>Statistiche dell'applicazione</h4>
            <div className={styleReport.marginInitialSezione} style={{height: "300px", backgroundColor: "#f0f0f0" }}>
                <div style={{textAlign: "center"}}><p style={{fontSize: "25px", fontWeight: "bold",paddingTop: "15px"}}>I numeri del Registro</p></div>
                <Row id={"grafico1"}  className={styleReport.marginInitialSezione}>
                    <div className={"col-4"} style={{textAlign: "center"}}>
                        <div className={styleReport.circleReport}>
                            <div className={styleReport.positionElementCircle}>
                                <p style={{fontSize: "18px", fontWeight: "bold"}}>Sportelli <br/>attivi</p>
                                <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{dataGrafico1.numSportelli}</p>
                            </div>
                        </div>
                    </div>

                    <div className={"col-4"} style={{textAlign: "center"}}>
                        <div className={styleReport.circleReport}>
                            <div className={styleReport.positionElementCircle}>
                                <p style={{fontSize: "18px", fontWeight: "bold"}}>Referenti <br/>dei Comuni</p>
                                <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{dataGrafico1.numUtenti}</p>
                            </div>
                        </div>
                    </div>

                    <div className={"col-4"} style={{textAlign: "center"}}>
                        <div className={styleReport.circleReport}>
                            <div className={styleReport.positionElementCircle}>
                                <p style={{fontSize: "18px", fontWeight: "bold"}}>Assistenti <br/>Familiari</p>
                                <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{dataGrafico1.numAssistenti}</p>
                            </div>
                        </div>
                    </div>
                </Row>
            </div>

            <div style={{marginTop: "40px"}}>
                <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                <Row id={"grafico2"} style={{marginTop: "20px"}}>
                    <div  className={"col-3"}>
                        <div style={{marginTop: "50px", marginLeft: "40px"}}>
                            <span style={{fontWeight: "bold"}}>Seleziona un periodo:</span>
                            <Select
                                ariaLabel={"Seleziona un periodo"}
                                onChange={(event) => onClickSelectGrafico2(event.target.value)}
                                options={selectOptionsPeriodo}
                                id={"periodo"}
                                style={{width: "80%"}}
                                default={true}
                            />


                            <div className={"col-11"}
                                 style={{height: 70, border: "1px solid black", marginTop: "70px"}}>
                                <Row style={{height: "100%"}}>
                                    <div className={"col-8"}>
                                        <span style={{fontWeight: "bold", fontSize: "17px"}}>Accessi oggi</span>
                                    </div>
                                    <div style={{borderLeft: "1px solid black"}} className={"col-4"}>
                                        <span style={{fontWeight: "bold"}}>{grafico2AccessiOggi != null  ? grafico2AccessiOggi : "/"}</span>
                                    </div>
                                </Row>
                            </div>
                            <div className={"col-11"}
                                 style={{height: 70, borderLeft: "1px solid black", borderRight: "1px solid black"}}>
                                <Row style={{height: "100%"}}>
                                    <div className={"col-8"}>
                                        <span style={{fontWeight: "bold", fontSize: "17px"}}>Media Giornaliera</span>
                                    </div>
                                    <div style={{borderLeft: "1px solid black"}} className={"col-4"}>
                                        <span style={{fontWeight: "bold"}}>{grafico2MediaGiornaliera != null  ? grafico2MediaGiornaliera : "/"}</span>
                                    </div>
                                </Row>
                            </div>
                            <div className={"col-11"} style={{height: 70, border: "1px solid black"}}>
                                <Row style={{height: "100%"}}>
                                    <div className={"col-8"}>
                                        <span style={{fontWeight: "bold", fontSize: "17px"}}>Media Mensile</span>
                                    </div>
                                    <div style={{borderLeft: "1px solid black"}} className={"col-4"}>
                                        <span style={{fontWeight: "bold"}}>{grafico2MediaMensile != null ? grafico2MediaMensile : "/"}</span>
                                    </div>
                                </Row>
                            </div>

                        </div>
                    </div>

                    <div style={{ height: 400, textAlign: "center"}} className={"col-8"}>
                        <span style={{fontWeight: "bold"}}>Visualizzazioni sito</span>
                        {boxGrafico2}
                    </div>
                </Row>
            </div>

            <div style={{marginTop: "40px"}}>
                <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                <div style={{marginTop: "20px",textAlign: "center"}}><span style={{fontWeight: "bold"}}>Utenti registrati</span></div>
                <Row id={"grafico3"}>
                    <div style={{marginTop: "40px",height: 400,textAlign: "center"}} className={"col-5"}>
                        <span style={{fontWeight: "bold"}}>Distribuzione Assistenti Familiari</span>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart width={600} height={600}>
                                <Pie
                                    dataKey="value"
                                    isAnimationActive={false}
                                    data={dataGrafico2atorta}
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={120}
                                    fill="#8884d8"
                                    label
                                >
                                {dataGrafico2atorta.map((oggetto, index) => (
                                    <Cell key={`cell-${index}`} fill={oggetto.color}/>
                                ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div style={{height: 400,textAlign: "center"}} className={"col-6"}>
                        <span style={{fontWeight: "bold"}}>Distribuzione utenti regionali</span>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                width={500}
                                height={300}
                                data={dataGrafico3UtentiRegionali}
                                margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                                barSize={50}
                            >
                                <XAxis
                                     dataKey="name" scale="point" padding={{ left: 40, right: 40 }} />
                                <YAxis
                                    // domain={[0, 'dataMax+1000']}
                                />
                                <Tooltip />
                                <Legend />
                                <CartesianGrid strokeDasharray="3 3" />
                                <Bar dataKey="ruolo" fill="#8884d8" background={{ fill: '#eee' }} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Row>
            </div>


            <div style={{marginTop: "40px"}}>
                <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                <Row className={"marginReport"}>
                    <div id={"grafico4"} style={{marginTop: "20px",textAlign: "center"}} className={"col-5"}>
                        <div style={{fontWeight: "bold", marginBottom: "1rem"}}><span >Assistenti Familiari registrati per sportello</span></div>

                        <Table
                            customStyleTable={"table-bordered"}
                            customStyleTh={{backgroundColor: "#4471c5", color: "white"}}
                            cols={colsSportelloAssistenti}
                            rows={rowsSportelloAssistenti}
                            id={"tabellaReport"}
                            sizeElementView={true}
                            size={pagination.size}
                            changePaginationSize={changePaginationSize}
                        />
                        <Pagination pagination={pagination} changePage={changePage} className={"noPrint"}/>
                        {/*    <tr style={{backgroundColor: "#dbe1ee"}}>*/}

                    </div>

                    <div className={"col-1"}></div>

                    <div id={"grafico41"} style={{ marginTop: "20px",textAlign: "center"}} className={"col-5"}>
                        <span style={{fontWeight: "bold"}}>Assistenti Familiari disponibili ( attivi ) per provincia</span>
                        <div style={{height: "500px"}}>
                            <ResponsiveContainer width="100%" height="100%">
                                <ComposedChart
                                    layout="vertical"
                                    width={500}
                                    height={400}
                                    data={dataGrafico6Province}
                                    margin={{
                                        top: 20,
                                        right: 20,
                                        bottom: 20,
                                        left: 20,
                                    }}
                                >
                                    <CartesianGrid stroke="#f5f5f5" />
                                    <XAxis type="number" domain={[0, 'dataMax']}/>
                                    <YAxis dataKey="name" type="category" scale="band" />
                                    <Tooltip />
                                    <Bar dataKey="value" barSize={30}>
                                        {dataGrafico6Province.map((oggetto, index) => (
                                            <Cell key={`cell-${index}`} fill={oggetto.color}/>
                                        ))}
                                    </Bar>
                                </ComposedChart>
                            </ResponsiveContainer>
                            <span style={{color: "grey"}}>Assistenti Familiari disponibili per provincia</span>
                        </div>
                    </div>
                </Row>

                <div className={"marginReport"} style={{marginTop: "40px"}}>
                    <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                    <Row id={"grafico5"}>
                        <div style={{marginTop: "20px", textAlign: "center"}} className={"col-6"}>
                            <span style={{fontWeight: "bold"}}>Filtri territoriali utilizzati</span>
                            <div style={{height: "500px"}}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <ComposedChart
                                        layout="vertical"
                                        width={500}
                                        height={400}
                                        data={dataGrafico7RicerchePerTerritorio}
                                        margin={{
                                            top: 20,
                                            right: 20,
                                            bottom: 20,
                                            left: 20,
                                        }}
                                    >
                                        <CartesianGrid stroke="#f5f5f5"/>
                                        <XAxis type="number" domain={[0, 'dataMax']}/>
                                        <YAxis dataKey="name" type="category" scale="band"/>
                                        <Tooltip/>
                                        <Bar dataKey="value" barSize={30}>
                                            {dataGrafico7RicerchePerTerritorio.map((oggetto, index) => (
                                                <Cell key={`cell-${index}`} fill={oggetto.color}/>
                                            ))}
                                        </Bar>
                                    </ComposedChart>
                                </ResponsiveContainer>
                                <span style={{color: "grey"}}>Numero Ricerche</span>
                            </div>
                        </div>
                        <div style={{marginTop: "20px",height: 400,textAlign: "center"}} className={"col-6"}>
                            <span style={{fontWeight: "bold"}}>Distribuzione accessi utenti registrati</span>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart width={600} height={600}>
                                    <Pie
                                        dataKey="value"
                                        data={dataGrafico89atorta.dataGrafico8atorta}
                                        outerRadius={160}
                                        fill="#8884d8"
                                        label={renderCustomizedLabel}
                                        labelLine={false}
                                    >
                                        {dataGrafico89atorta.dataGrafico8atorta.map((oggetto, index) => (
                                            <Cell key={`cell-${index}`} fill={oggetto.color}/>
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '80px' }}/>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Row>
                </div>

                <div style={{marginTop: "40px"}} >
                    <hr style={{backgroundColor: "#c4bebe", border: "1px solid #c4bebe"}}/>
                    <Row id={"grafico6"}>
                        <div style={{marginTop: "20px",height: 400,textAlign: "center"}} className={"col-6"}>
                       <span style={{fontWeight: "bold"}}>Assistenti Familiari da contattare trovati con il Registro</span>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart width={600} height={600}>
                                    <Pie
                                        dataKey="value"
                                        data={dataGrafico89atorta.dataGrafico9atorta}
                                        outerRadius={140}
                                        fill="#8884d8"
                                        label={renderCustomizedLabel}
                                        labelLine={false}
                                    >
                                        {dataGrafico89atorta.dataGrafico9atorta.map((oggetto, index) => (
                                            <Cell key={`cell-${index}`} fill={oggetto.color}/>
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '80px' }}/>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Row>

                    <div className={"noPrint"} style={{textAlign: "center", marginTop: "40px"}}>
                    <Button
                        id={"stampaReport"}
                        typeButton={"White"}
                        text={"Stampa"}
                        style={{height: "45px", width: "200px"}}
                        onClick={() => stampa()}
                    />
                    </div>
                </div>
            </div>

            {tableFeedback}


        </div>

    )


}
export default Report
